import { useCallback } from 'react';

import { useCardOfferContext } from '../../context/selectors';

export function useDownloadPDF(): VoidFunction {
  const {
    data: { url },
  } = useCardOfferContext();

  return useCallback(() => {
    window.open(url.replace('cian.ru/', 'cian.ru/export/pdf/'), '_blank');
  }, [url]);
}
